import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    title: String,
    buttonLabel: String,
    buttonLink: String,
    urgent: Boolean,
  };

  connect() {
    this.addTrackingOnClick(this.setTrackingData());
    this.getDashboardPage();
  }

  addTrackingOnClick(trackingData) {
    const button = this.element.querySelector('div[name="button"]');

    if (!button) return;

    button.addEventListener("click", () => {
      window.sendSegmentAnalytics("Nok", this.getDashboardPage(), "task CTA clicked", {
        ...trackingData,
      });
    });
  }

  getDashboardPage() {
    const path = window.location.pathname.split("/")[2];
    const page = path.split("_").join(" ");

    return "dashboard" + " " + page;
  }

  setTrackingData() {
    return {
      taskTitle: this.titleValue,
      taskButtonLabel: this.buttonLabelValue,
      taskButtonLink: this.buttonLinkValue,
      taskUrgent: this.urgentValue,
    };
  }
}
